import App from './app.js';

const bootError = (msg) => {
  console.error(msg);
  const p = document.createElement('p');
  p.setAttribute('role', 'alert');
  p.style.cssText = 'color:#ff5f7a;padding:1rem;font-family:sans-serif;';
  p.textContent = String(msg);
  document.body.prepend(p);
};

try {
  const app = new App();
  app.init().catch(bootError);
} catch (err) {
  bootError(err?.message || err);
}
